module.exports = function (cb) {
	var endpointUrl = URI('/api/search/productsearch/displayinner');
	var data = {
		FacetIds: [],
		DatasourceId: $('#product-search-page-datasource-id').val()
	};

	if (window.q && window.q.length) {
		endpointUrl.setQuery('q', window.q);
	}
	
	if (window.page > 1) {
		endpointUrl.setQuery('page', window.page);
	}

	if (window.searchFilters && window.searchFilters.facetIds) {
		data.facetIds = window.searchFilters.facetIds;
	}

	$.ajax({
		method: 'POST',
		url: endpointUrl.toString(),
		data: JSON.stringify(data),
		contentType: "application/json",
		success: function (result) {
			if (cb) {
				cb(result);
			}
		},
		error: function (xhr, status, error) {
			console.log('error');
			console.log(error);
			return { 'error': error };
		}
	});
};
